import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';

const SearchResult = ({ title, url, content, handleClick }) => (
  <div className={styles.searchResult}>
    <h2 className={styles.title}>
      <a onClick={handleClick} href={url}>
        {title}
      </a>
    </h2>
    <p className={styles.description}>
      <a
        onClick={handleClick}
        href={url}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </p>
  </div>
);

SearchResult.propTypes = {
  handleClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired
};

export default SearchResult;
